'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("groupeService", function ($http, $session) {
  return {
    HORS_GROUPE: 'HORS_GROUPE',
    TOUS: 'TOUS',
    /**
     * liste des groupes existants pour le compte visualisé
     * @returns {*}
     */
    getGroupes: function getGroupes() {
      return $http.get('/rest/groupes').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @param groupeId
     * @returns {*} un SimpleValidationDTO
     */
    deleteGroupe: function deleteGroupe(groupeId) {
      return $http.delete('/rest/groupes/delete/' + groupeId).then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} Les groupes accessibles a l'utilisateurs (tous les groupes si aucun groupe sur le user)
     */
    getUserGroupes: function getUserGroupes() {
      var groupIds = $session.getUser().groupeIds;
      if (groupIds.length === 0) {
        return $http.get('/rest/groupes').then(function (response) {
          return response.data;
        });
      } else return $http.get('/rest/groupes').then(function (response) {
        return _.filter(response.data, function (groupe) {
          return _.includes(groupIds, groupe.id);
        });
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/groupeService.js
// module id = 2873
// module chunks = 13